import { parseBulkText } from "./parseBulkText";
import { fetchProductByCode } from "./fetchProductByCode";
import { addOrMergeOrderItem } from "./addOrMergeOrderItem";

export const handleBulkPaste = async ({
    rawText,
    items,
    user,
    myaccountId,
}) => {
    let nextItems = [...items];
    const bulkErrors = [];

    const parsedRows = parseBulkText(rawText);

    for (const row of parsedRows) {
        const product = await fetchProductByCode({
            code: row.code,
            user,
            myaccountId,
        });

        if (!product) {
            bulkErrors.push({ code: row.code, reason: "Producto no encontrado" });
            nextItems.unshift({
                code: row.code,
                qty: row.qty,
                isError: true,
                errorReason: "Producto no encontrado",
            });
            continue;
        }

        addOrMergeOrderItem({
            items: nextItems,
            setItems: (updater) => {
                nextItems = typeof updater === "function" ? updater(nextItems) : updater;
            },
            product,
            qtyToAdd: row.qty,
            user,
        });
    }

    return { nextItems, bulkErrors };
};
